<ng-template #cadastroClienteModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Cadastro de Cliente</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="clienteForm">
      <!-- 1. Dados da Empresa -->
      <div class="section-title mb-3">
        <h5>1. Dados da Empresa</h5>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Razão Social *</label>
            <input type="text" class="form-control" formControlName="razaoSocial" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Nome Fantasia *</label>
            <input type="text" class="form-control" formControlName="nomeFantasia" required>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>CNPJ *</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="cnpj" required>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" (click)="consultarCNPJ()">
                  <i class="anticon anticon-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Data de fundação</label>
            <input type="date" class="form-control" formControlName="dataFundacao">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>Inscrição Estadual</label>
            <input type="text" class="form-control" formControlName="inscricaoEstadual">
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Inscrição Municipal</label>
            <input type="text" class="form-control" formControlName="inscricaoMunicipal">
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Ramo de Atividade / CNAE</label>
            <input type="text" class="form-control" formControlName="ramoAtividade">
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Porte da empresa</label>
        <div class="row">
          <div class="col-md-2">
            <div class="form-check">
              <input class="form-check-input" type="radio" formControlName="porteEmpresa" value="MEI">
              <label class="form-check-label">MEI</label>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-check">
              <input class="form-check-input" type="radio" formControlName="porteEmpresa" value="ME">
              <label class="form-check-label">ME</label>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-check">
              <input class="form-check-input" type="radio" formControlName="porteEmpresa" value="EPP">
              <label class="form-check-label">EPP</label>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-check">
              <input class="form-check-input" type="radio" formControlName="porteEmpresa" value="MEDIA">
              <label class="form-check-label">Média</label>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-check">
              <input class="form-check-input" type="radio" formControlName="porteEmpresa" value="GRANDE">
              <label class="form-check-label">Grande</label>
            </div>
          </div>
        </div>
      </div>

      <!-- 2. Endereço Comercial -->
      <div class="section-title mb-3 mt-4">
        <h5>2. Endereço Comercial</h5>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>CEP *</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="cep" required>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" (click)="consultarCEP()">
                  <i class="anticon anticon-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="form-group">
            <label>Rua / Logradouro *</label>
            <input type="text" class="form-control" formControlName="logradouro" required>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <div class="form-group">
            <label>Número *</label>
            <input type="text" class="form-control" formControlName="numero" required>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Complemento</label>
            <input type="text" class="form-control" formControlName="complemento">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Bairro *</label>
            <input type="text" class="form-control" formControlName="bairro" required>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Cidade *</label>
            <input type="text" class="form-control" formControlName="cidade" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Estado (UF) *</label>
            <select class="form-control" formControlName="estado" required>
              <option value="">Selecione...</option>
              <option *ngFor="let uf of estados" [value]="uf">{{uf}}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- 3. Contato da Empresa -->
      <div class="section-title mb-3 mt-4">
        <h5>3. Contato da Empresa</h5>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>E-mail comercial *</label>
            <input type="email" class="form-control" formControlName="emailComercial" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Telefone comercial *</label>
            <input type="text" class="form-control" formControlName="telefoneComercial" required>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>WhatsApp da empresa</label>
            <input type="text" class="form-control" formControlName="whatsapp">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Site da empresa</label>
            <input type="url" class="form-control" formControlName="site">
          </div>
        </div>
      </div>

      <!-- 4. Responsável pelo Cadastro -->
      <div class="section-title mb-3 mt-4">
        <h5>4. Responsável pelo Cadastro</h5>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Nome completo *</label>
            <input type="text" class="form-control" formControlName="nomeResponsavel" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>CPF *</label>
            <input type="text" class="form-control" formControlName="cpfResponsavel" required>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Cargo na empresa *</label>
            <input type="text" class="form-control" formControlName="cargoResponsavel" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Telefone celular *</label>
            <input type="text" class="form-control" formControlName="telefoneResponsavel" required>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>E-mail do responsável *</label>
            <input type="email" class="form-control" formControlName="emailResponsavel" required>
          </div>
        </div>
      </div>

      <!-- 5. Informações de Acesso -->
      <div class="section-title mb-3 mt-4">
        <h5>5. Informações de Acesso</h5>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Usuário ou e-mail de login *</label>
            <input type="text" class="form-control" formControlName="usuario" required>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Senha *</label>
            <input type="password" class="form-control" formControlName="senha" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Confirmar senha *</label>
            <input type="password" class="form-control" formControlName="confirmarSenha" required>
          </div>
        </div>
      </div>

      <!-- 6. Documentação -->
      <div class="section-title mb-3 mt-4">
        <h5>6. Documentação</h5>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Contrato social ou Requerimento de Empresário *</label>
            <input type="file" class="form-control" formControlName="contratoSocial" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Comprovante de endereço empresarial *</label>
            <input type="file" class="form-control" formControlName="comprovanteEndereco" required>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Documento do responsável (RG ou CNH)</label>
            <input type="file" class="form-control" formControlName="documentoResponsavel">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Cartão CNPJ (PDF ou imagem) *</label>
            <input type="file" class="form-control" formControlName="cartaoCnpj" required>
          </div>
        </div>
      </div>

      <!-- 7. Termos e Autorizações -->
      <div class="section-title mb-3 mt-4">
        <h5>7. Termos e Autorizações</h5>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" formControlName="termosUso" required>
          <label class="form-check-label">
            Li e aceito os <a href="#">Termos de Uso</a> e a <a href="#">Política de Privacidade</a>
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" formControlName="lgpd" required>
          <label class="form-check-label">
            Autorizo o uso dos meus dados conforme a LGPD
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" formControlName="autorizacao" required>
          <label class="form-check-label">
            Declaro estar autorizado a representar esta empresa neste cadastro
          </label>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss('Cancel')">Cancelar</button>
    <button type="button" class="btn btn-primary" [disabled]="clienteForm.invalid" (click)="salvarCliente(); modal.close('Save click')">Salvar</button>
  </div>
</ng-template>

<div class="main-content">
  <div class="page-header">
    <h2 class="header-title">Clientes</h2>
    <div class="header-sub-title">
      <nav class="breadcrumb breadcrumb-dash">
        <a href="#" class="breadcrumb-item"><i class="anticon anticon-home m-r-5"></i>Home</a>
        <span class="breadcrumb-item active">Clientes</span>
      </nav>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="row m-b-30">
        <div class="col-lg-8">
          <div class="d-md-flex">
            <div class="m-b-10 m-r-15">
              <button class="btn btn-primary" (click)="novoCliente(cadastroClienteModal)">
                <i class="anticon anticon-plus-circle m-r-5"></i>
                <span>Novo Cliente</span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4 text-right">
          <div class="d-inline-block">
            <div class="input-affix m-b-10">
              <i class="prefix-icon anticon anticon-search"></i>
              <input type="text" class="form-control" placeholder="Buscar cliente" [(ngModel)]="searchText">
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-hover e-commerce-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>Telefone</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cliente of clientes">
              <td>{{cliente.nome}}</td>
              <td>{{cliente.email}}</td>
              <td>{{cliente.telefone}}</td>
              <td>
                <div class="d-flex align-items-center">
                  <div class="badge badge-success badge-dot m-r-10"></div>
                  <span>{{cliente.status}}</span>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <button class="btn btn-icon btn-hover btn-sm btn-rounded" (click)="editarCliente(cliente.id)">
                    <i class="anticon anticon-edit"></i>
                  </button>
                  <button class="btn btn-icon btn-hover btn-sm btn-rounded" (click)="excluirCliente(cliente.id)">
                    <i class="anticon anticon-delete"></i>
                  </button>
                  <button class="btn btn-primary btn-sm m-l-5" (click)="editarCliente(cliente.id)">
                    <i class="bi bi-pencil m-r-5"></i>
                    Editar
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div> 